import { getErrorAsString, IAuthCookie } from '@notes/webintegrations-common'
import { Log } from '../../shared/logger/Log'
import { o365CommonAuthAccessToken } from './localStorageIsSignedInKey'

export function getO365AccessTokenInfoFromLocalStorage(): IAuthCookie | undefined {
  if (!localStorage) {
    Log.logger.error('Local storage is disabled. We will not be able to get o365 credentials.')
    return undefined
  }

  let credentials: string | null = null
  const localStorageKey = o365CommonAuthAccessToken
  try {
    credentials = localStorage.getItem(localStorageKey)
  } catch (error) {
    Log.logger.warn(`Cache ${localStorageKey}: Unable to get element ${getErrorAsString(error)}`)
  }
  if (!credentials) {
    Log.logger.info('Could not find o365 credentials in local storage.')
    return undefined
  }

  Log.logger.info('Found o365 credentials in local storage.')
  let jsonInStorage: IAuthCookie | null = null
  try {
    jsonInStorage = JSON.parse(credentials) as IAuthCookie
  } catch (error) {
    Log.logger.error(`Error parsing o365 credentials from local storage: ${getErrorAsString(error)}`)
    return undefined
  }
  if (isValidO365Credentials(jsonInStorage)) {
    return jsonInStorage
  }

  Log.logger.info('Found o365 credentials in local storage, but they did not have the expected properties.')
  return undefined
}

export function isValidO365Credentials(cred: IAuthCookie): boolean {
  return !!(cred && cred.access_token &&  cred.expires_in)
}
